import axiosInstance from "../../../axios";
import config from "../../../config";
import { usePersistedStore } from "../../persisted-store";
import { message as antdMsg } from "antd";
export const createUnderReviewReportSlice = (set, get) => ({
    underReview: {
        loading: false,
        data: [],
        comments: []
    },

    postInsuranceDetailsComment: async ({ insuranceRequestId, message, attachFile }) => {
        const token = usePersistedStore.getState().business.currentBusiness.token;
        set(state => ({ underReview: { ...state.underReview, loading: true } }));

        try {
            const resp = await axiosInstance({
                method: "post",
                baseURL: config.apiUrls(),
                url: `v1/business/insurance/${insuranceRequestId}/comment`,
                headers: { token },
                data: { message }
            });

            const uploadFiles = async (commentId) => {
                const formData = new FormData();

                const uniqueFiles = new Map();

                attachFile.forEach((file) => {
                    if (!uniqueFiles.has(file.name)) {
                        uniqueFiles.set(file.name, file);
                    }
                });

                uniqueFiles.forEach((file) => {
                    formData.append(file.name, file);
                });

                await axiosInstance({
                    method: "post",
                    baseURL: config.apiUrls(),
                    url: `v1/business/insurance/comment/${commentId}/file`,
                    headers: {
                        token,
                        "Content-Type": "multipart/form-data"
                    },
                    data: formData
                });
            };

            if (attachFile.length > 0) {
                await uploadFiles(resp.data.Id);
            }

            await get().getInsuranceDetailsComments(insuranceRequestId);
            set(state => ({ underReview: { ...state.underReview, loading: false } }));
            antdMsg.success("کامنت با موفقیت ثبت شد.");
        } catch (error) {
            set(state => ({ underReview: { ...state.underReview, loading: false } }));
        }
    },

    getInsuranceDetailsComments: async (insuranceRequestId) => {
        const token = usePersistedStore.getState().business.currentBusiness.token;
        set(state => ({
            underReview: {
                ...state.underReview,
                loading: true
            }
        }));
        try {
            const resp = await axiosInstance({
                method: "get",
                baseURL: config.apiUrls(),
                url: `v1/business/insurance/${insuranceRequestId}/Comment`,
                headers: { token }
            });
            set(state => ({
                underReview: {
                    ...state.underReview,
                    comments: resp.data.Comments,
                    loading: false
                }
            }));

        } catch (error) {
            set(state => ({
                underReview: {
                    ...state.underReview,
                    loading: false
                }
            }));
        }
    },
    getUnderReview: async (params) => {
        const token = usePersistedStore.getState().business.currentBusiness.token;
        set(state => ({ underReview: { ...state.underReview, loading: true } }));
        try {

            const resp = await axiosInstance({
                method: "post",
                baseURL: config.apiUrls(),
                url: "v1/business/business-under-review-report",
                headers: { token },
                data: {
                    PageNumber: params.PageNumber,
                    PageSize: params.PageSize,
                },
            });
            set(state => ({ underReview: { ...state.underReview, loading: false, data: resp.data } }));
        } catch (error) {
            set(state => ({ underReview: { ...state.underReview, loading: false } }));
            console.error("Error fetching under review report:", error);
        }
    }
});
